import api from './api'
import axios from 'axios'

export const orderService = {
  async verifyOrdersCost(vendor, orderIds) {
    return await api.post(`/orders/verify-cost/${vendor}`, { ids: orderIds })
  },
  async assignVendor(vendor, orderIds, from) {
    return await api.post(`/vendors/assign-vendor/${vendor}`, {
      orderIds,
      from
    })
  },
  async submitEmailOrders(vendor, formData) {
    return await api.post(`/orders/submit-email/${vendor}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  async submitVerifiedOrders(vendor, orderIds, submited_by) {
    return await api.post(`/orders/submit-orders/${vendor}`, {
      ids: orderIds,
      submited_by
    })
  },
  async exportOrders(vendorSlug) {
    const response = await axios.post(`${api.defaults.baseURL}/vendors/export/${vendorSlug}`, {}, {
      responseType: 'blob',
      headers: api.defaults.headers
    })
    return response.data
  },
  async updateCheckedStatus(orderId, checked) {
    return await api.post(`/orders/${orderId}/item-checked`, {
      checked
    })
  },
  async assignEbayOrder(vendorSlug, orderId, newPartNumber) {
    return await api.post(`/vendors/assign-ebay-order/${vendorSlug}`, {
      orderId,
      newPartNumber
    })
  }
} 